import React from 'react'

export default function ArrowRightSmallIcon({ width = 11, height = 11, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.33333 0.667969L10 5.33464M10 5.33464L5.33333 10.0013M10 5.33464H0.666666" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
